import {useCallback} from 'react';
import Sample from 'repos/Sample.js';

export const loadSample = (
    sequencerEngine,
    setSamplersLoaded,
    samplersLoaded) =>
    useCallback(async (sampleId) => {
        let track = sequencerEngine
            .samplerTrack
            .addSampledInstrumentTrack();
        
        let sample = new Sample(sampleId);
        await sample.load();
        await track.instrument.newSample(0, sample);
        track.instrument.monophonic = true;
        setSamplersLoaded(
            [... sequencerEngine.samplerTrack.tracks]);
 
    }, [setSamplersLoaded, samplersLoaded, sequencerEngine]);

export const deleteSample = (
    setSamplersLoaded,
    samplersLoaded,
    sequencerEngine) =>
    useCallback((sample) => {
        sequencerEngine.samplerTrack.deleteTrack(sample.trackNumber);
        setSamplersLoaded([... sequencerEngine.samplerTrack.tracks]);
    }, [setSamplersLoaded, samplersLoaded, sequencerEngine]);


